import { render, staticRenderFns } from "./Inspect.vue?vue&type=template&id=e8c7c994&scoped=true"
import script from "./Inspect.vue?vue&type=script&lang=js"
export * from "./Inspect.vue?vue&type=script&lang=js"
import style0 from "./Inspect.vue?vue&type=style&index=0&id=e8c7c994&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8c7c994",
  null
  
)

export default component.exports